
import React from 'react'

function SearchButton() {
  return (
    <button className="btn btn-primary">Search</button>
  )
}

export default SearchButton
